import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	box: {
		border: "1px solid #d1d5db",
		borderRadius: "4px",
		padding: "12px 14px",
		backgroundColor: "#f8fafc",
		fontSize: "13px",
		whiteSpace: "pre-line",
		lineHeight: 1.5,
	},
}));

const SubscriptionSummary = ({ summary }) => {
	const { classes } = useStyles();
	if (!summary) return null;
	return <div className={classes.box}>{summary}</div>;
};

export default SubscriptionSummary;
